/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierStarterLtiEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('TIER_STARTER_LTI_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class TierStarterLtiEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierStarterLtiEnabledSettingParser.decode(input).map(res => new TierStarterLtiEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return TierStarterLtiEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierStarterLtiEnabledSettingParser.encode(data);
    }
    static schema() {
        return TierStarterLtiEnabledSettingParser.schema();
    }
}
